import {
  useAuth,
  useInitializeOfflineData,
  useInitializeOfflineMode,
  useParams,
  useNavigate
} from "duck";
import { useCompleteRegistrationMutation } from "requests";
import { FormValues } from "./types";

export const useCompleteRegistration = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [, setAuth] = useAuth();

  const [complete] = useCompleteRegistrationMutation({ ignoreResults: true });

  const initOffline = useInitializeOfflineMode();
  const { initOfflineData } = useInitializeOfflineData();

  return ({ password, pin }: FormValues) =>
    complete({
      variables: {
        input: {
          registrationToken: id,
          plainPassword: password,
          plainPin: +pin
        }
      }
    }).then(({ data }) => {
      const user =
        data?.createRegistrationCompletion?.registrationCompletion
          ?.applicationSettings.user;
      const sessionId =
        data?.createRegistrationCompletion?.registrationCompletion?.sessionId;

      if (!sessionId || !user) {
        return;
      }

      localStorage.setItem("sessionId", sessionId);
      setAuth(prev => ({ ...prev, user }));

      initOfflineData(user.organization?._id);
      initOffline(user);

      navigate("/cases", { replace: true });
    });
};
